import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['invoiceEmail']

  displayInvoiceEmailForm(event) {
    this.invoiceEmailTarget.classList.add('hidden')
    if (event.target.checked) this.invoiceEmailTarget.classList.remove('hidden')
  }
}
